<template>
  <div>
    <v-data-table v-model="table.selected" :headers="table.headers" :server-items-length="getTotalItems()"
      :items="notifications ? notifications.data : []"
      :items-per-page="notifications && notifications.meta ? parseInt(notifications.meta.per_page) : 0"
      :page.sync="table.page" :options.sync="table.options" :sort-by.sync="table.sortBy" :sort-desc.sync="table.sortDesc"
      :loading="table.loading" @click:row="rowClick" hide-default-footer item-key="name" class="elevation-1 mt-4">
      <template v-slot:top>
        <v-row class="px-3">
          <v-col cols="12" sm="12" md="3" xs="12">
            <v-select :items="allStatus" v-model="table.filters.unread" item-text="text" item-value="id" menu-props="auto"
              label="Lidas/Não lidas" hide-details single-line solo color="primary" dense></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" xs="12">
            <date-picker hide-details clearable label="De" noIcon dense v-on:change="changeSchedulingDateStart" />
          </v-col>
          <v-col cols="12" sm="6" md="3" xs="12">
            <date-picker hide-details clearable label="Até" noIcon dense v-on:change="changeSchedulingDateEnd" />
          </v-col>
        </v-row>

        <v-row class="px-3">
          <v-col cols="12" sm="12" md="3" xs="12">
            <v-btn :loading="table.loading" small color="primary" class="mr-4" @click="fetchNotifications">
              <v-icon left>mdi-filter</v-icon>
              Aplicar
            </v-btn>
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.title="{ item }">
        <strong v-if="!item.read">{{ item.title }}</strong>
        <span v-else>{{ item.title }}</span>
      </template>

      <template v-slot:item.body="{ item }">
        <strong v-if="!item.read">{{ item.body }}</strong>
        <span v-else>{{ item.body }}</span>
      </template>

      <template v-slot:item.created_at="{ item }">
        <strong v-if="!item.read">{{ item.created_at }}</strong>
        <span v-else>{{ item.created_at }}</span>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item link @click="() => readNotification(item.id)">
              <v-list-item-title>Marcar como lida</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-slot:footer>
        <v-pagination class="mb-4" v-model="table.page"
          :length="notifications && notifications.meta ? Math.floor(parseInt(notifications.meta.total) / parseInt(notifications.meta.per_page)) : 0"></v-pagination>
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar.show" timeout="3000" :color="snackbar.color">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { handleResponseError } from '@/api/handleError'
import DatePicker from '@/components/DatePicker'

export default {
  name: 'Notifications',
  computed: {
    ...mapState({
      notifications: state => state.notifications.all,
    })
  },
  components: {
    DatePicker,
  },
  methods: {
    clearFilters: function () {
      this.table.filters = {
        search: '',
        date_start: '',
        date_end: '',
        unread: null,
      }
    },
    fetchNotifications: async function () {
      this.table.loading = true
      await this.$store.dispatch('notifications/getNotifications', {
        date_start: this.table.filters.date_start,
        date_end: this.table.filters.date_end,
        search: this.table.filters.search,
        unread: this.table.filters.unread,
        limit: this.limit,
        page: this.page,
        desc: this.sortDesc,
        sort: this.sortBy,
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar as notificações.')
        this.showNotification(message, 'red darken-2')
        this.table.loading = false
      })
      this.table.loading = false
    },
    changeSchedulingDateStart: function (date) {
      this.table.filters.date_start = date
    },
    changeSchedulingDateEnd: function (date) {
      this.table.filters.date_end = date
    },
    showNotification: function (message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    rowClick: function (item) {
      this.$router.push('/notification/' + item.id).catch(() => { })
    },
    getTotalItems: function () {
      return this.notifications && this.notifications.meta ? parseInt(this.notifications.meta.total) : 0
    },
    readNotification: async function (id) {
      this.loadingRead = true
      await this.$store.dispatch('notifications/markAsRead', id)
        .then(() => {
          this.sortBy = 'created_at'
          this.sortDesc = true
          this.page = 1
          this.limit = 10
          this.fetchNotifications()
          this.$store.dispatch('layout/getSidebarNotifications')
          this.showNotification('Notificação lida', 'green')
        })
        .catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao atualizar a notificação.')
          this.showNotification(message, 'red darken-2')
          this.loadingRead = false
        })
      this.loadingRead = false
    },
    readAllNotification: async function (id) {
      this.loadingRead = true
      await this.$store.dispatch('notifications/markAllAsRead', id)
        .then(() => {
          this.sortBy = 'created_at'
          this.sortDesc = true
          this.page = 1
          this.limit = 10
          this.fetchNotifications()
          this.$store.dispatch('layout/getSidebarNotifications')
          this.showNotification('Notificações lidas', 'green')
        })
        .catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao atualizar a notificação.')
          this.showNotification(message, 'red darken-2')
          this.loadingRead = false
        })
      this.loadingRead = false
    },
  },
  watch: {
    'table.options': function (options) {
      const sortBy = options.sortBy[0]
      const sortDesc = options.sortDesc[0]

      this.sortBy = sortBy
      this.sortDesc = sortDesc
      this.page = options.page
      this.limit = 10

      this.fetchNotifications()
    },
  },
  data: () => ({
    sortBy: 'created_at',
    sortDesc: true,
    limit: 10,
    page: 1,
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
    loadingRead: false,
    table: {
      loading: false,
      filters: {
        search: '',
        date_start: '',
        date_end: '',
        unread: null,
      },
      headers: [
        { text: 'Título', value: 'title' },
        { text: 'Descrição', value: 'body' },
        { text: 'Data', value: 'created_at' },
        { text: '', value: 'actions', sortable: false },
      ],
      page: 1,
      sortBy: 'created_at',
      sortDesc: true,
    },
    allStatus: [
      { id: null, text: 'Todas' },
      { id: 1, text: 'Não lidas' },
      { id: 2, text: 'Lidas' },
    ],
  }),
}
</script>
